import searchBox from '@motionelements/core/src/store/modules/search-box.js';

export default {
  namespaced: true,
  state: () => searchBox.state,
  getters: searchBox.getters,
  actions: searchBox.actions,
  mutations: searchBox.mutations,
};
